// -*- coding: utf-8 -*-
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

export default function MessageComposer({
  text,
  onChangeText,
  onDraftChange,
  onSend,
  disabled,
  disableSend,
  sending,
  palette,
  useDarkWhatsApp,
  placeholder = 'Mesaj yazın',
}) {
  return (
    <Box sx={{ display: 'flex', gap: 1, backgroundColor: palette.CHAT_BG }}>
      <TextField
        size="small"
        placeholder={placeholder}
        value={text}
        onChange={(e) => {
          const v = e.target.value;
          onChangeText(v);
          if (onDraftChange) onDraftChange(v);
        }}
        fullWidth
        disabled={disabled}
        multiline
        maxRows={4}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
            onSend();
          }
        }}
        InputProps={{ sx: { backgroundColor: useDarkWhatsApp ? '#202C33' : '#FFFFFF', color: useDarkWhatsApp ? palette.TEXT : undefined } }}
      />
      <Button variant="contained" onClick={onSend} disabled={disableSend || sending} aria-label="Mesajı gönder">
        Gönder
      </Button>
    </Box>
  );
}
